"use strict";

var diff;

module.exports = function(a, opt) {
	if (a !== diff) {
		diff = a;
		return opt.fn(this);
	}

	return opt.inverse(this);
};



// WEBPACK FOOTER //
// ./client/js/libs/handlebars/diff.js